// Payment Service for LinkCab
class PaymentService {
  constructor() {
    this.walletBalance = this.getWalletBalance();
  }

  // Get wallet balance from localStorage
  getWalletBalance() {
    const balance = localStorage.getItem('walletBalance');
    return balance ? parseFloat(balance) : 1000; // Default balance of ₹1000
  }

  // Update wallet balance
  updateWalletBalance(amount) {
    this.walletBalance = amount;
    localStorage.setItem('walletBalance', amount.toString());
  }

  // Process payment
  async processPayment(amount, method, connectDetails) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        try {
          switch (method) {
            case 'wallet':
              if (this.walletBalance >= amount) {
                this.updateWalletBalance(this.walletBalance - amount);
                resolve({
                  success: true,
                  message: 'Payment successful via wallet',
                  transactionId: `TXN_${Date.now()}`,
                  method: 'wallet',
                  amount: amount
                });
              } else {
                reject({
                  success: false,
                  message: 'Insufficient wallet balance'
                });
              }
              break;

            case 'card':
              // Simulate card payment
              resolve({
                success: true,
                message: 'Payment successful via card',
                transactionId: `TXN_${Date.now()}`,
                method: 'card',
                amount: amount
              });
              break;

            case 'upi':
              // Simulate UPI payment
              resolve({
                success: true,
                message: 'Payment successful via UPI',
                transactionId: `TXN_${Date.now()}`,
                method: 'upi',
                amount: amount
              });
              break;

            default:
              reject({
                success: false,
                message: 'Invalid payment method'
              });
          }
        } catch (error) {
          reject({
            success: false,
            message: 'Payment failed',
            error: error.message
          });
        }
      }, 2000); // Simulate 2 second processing time
    });
  }

  // Add money to wallet
  async addToWallet(amount, method) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        try {
          this.updateWalletBalance(this.walletBalance + amount);
          resolve({
            success: true,
            message: `₹${amount} added to wallet via ${method}`,
            newBalance: this.walletBalance,
            transactionId: `TXN_${Date.now()}`
          });
        } catch (error) {
          reject({
            success: false,
            message: 'Failed to add money to wallet',
            error: error.message
          });
        }
      }, 1500);
    });
  }

  // Get transaction history
  getTransactionHistory() {
    const history = localStorage.getItem('transactionHistory');
    return history ? JSON.parse(history) : [];
  }

  // Save transaction to history
  saveTransaction(transaction) {
    const history = this.getTransactionHistory();
    history.unshift({
      ...transaction,
      timestamp: new Date().toISOString(),
      id: `TXN_${Date.now()}`
    });
    localStorage.setItem('transactionHistory', JSON.stringify(history.slice(0, 50))); // Keep last 50 transactions
  }

  // Get payment methods
  getPaymentMethods() {
    return [
      {
        id: 'wallet',
        name: 'LinkCab Wallet',
        icon: '💳',
        balance: this.walletBalance,
        description: 'Use your wallet balance'
      },
      {
        id: 'card',
        name: 'Credit/Debit Card',
        icon: '💳',
        description: 'Pay with your card'
      },
      {
        id: 'upi',
        name: 'UPI',
        icon: '📱',
        description: 'Pay via UPI'
      }
    ];
  }

  // Validate payment details
  validatePaymentDetails(method, details) {
    switch (method) {
      case 'card':
        return {
          valid: details.cardNumber && details.expiry && details.cvv,
          message: 'Please enter valid card details'
        };
      case 'upi':
        return {
          valid: details.upiId,
          message: 'Please enter valid UPI ID'
        };
      case 'wallet':
        return {
          valid: true,
          message: 'Wallet payment ready'
        };
      default:
        return {
          valid: false,
          message: 'Invalid payment method'
        };
    }
  }
}

export async function startRazorpayPayment({ amount, receipt, onSuccess, onFailure }) {
  // Call backend to create order
  const res = await fetch('/api/payments/create-order', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount, receipt }),
  });
  const order = await res.json();

  if (!order.id) {
    if (onFailure) onFailure(order);
    return;
  }

  const options = {
    key: 'rzp_test_lpv28BMDD8bT0M', // Test key
    amount: order.amount,
    currency: order.currency,
    name: 'LinkCab',
    description: 'Test Transaction',
    order_id: order.id,
    handler: function (response) {
      if (onSuccess) onSuccess(response);
    },
    prefill: {
      name: '',
      email: '',
      contact: '',
    },
    theme: {
      color: '#3399cc',
    },
  };

  const rzp = new window.Razorpay(options);
  rzp.on('payment.failed', function (response) {
    if (onFailure) onFailure(response);
  });
  rzp.open();
}

export default new PaymentService(); 